import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DashboardWrapper from "../containers/DashboardWrapper";
import {
  setCurrentPage,
  setFilterDownload,
  setCurrentPageNumber,
} from "../actions";
import DownloadCalendar from "../components/Calendar/DownloadCalendar";
import DownloadTable from "../components/Table/DownloadTable";
import LocalStorageHelper from "../utils/helper/localstorage_helper";

const useStyles = makeStyles((theme) => ({
  contentGrid: {
    marginTop: theme.spacing(1),
    width: "100%%",
  },
  contentGridSlim: {
    marginTop: theme.spacing(1),
    width: "90%",
  },
  root: {
    marginTop: 32,
    minWidth: 275,
  },
  title: {
    fontSize: 14,
  },
  filtered: {
    marginTop: 10,
    marginLeft: 16,
  },
  quickSearchWrap: {
    marginTop: 8,
    marginLeft: 8,
    width: 420,
    maxWidth: "100%",
  },
  quickSearchInput: {
    backgroundColor: "#fff",
  },
  resultCount: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: 14,
  },
}));

const Download = ({
  setCurrentPage,
  setFilterDownload,
  setCurrentPageNumber,
  filterDownload,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [downloadImage, setDownloadImage] = useState([]);
  const [fileNameOptions, setFileNameOptions] = useState([]);
  const [filteredCount, setFilteredCount] = useState(0);
  const companyName = LocalStorageHelper.getCompany();

  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, [setCurrentPage]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleImageSelect = (event, value) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setDownloadImage((prev) => [...prev, value]);
    } else {
      setDownloadImage((prev) => prev.filter((url) => url !== value));
    }
  };

  const selectedFileNameKeywords = Array.isArray(filterDownload?.fileNameKeywords)
    ? filterDownload.fileNameKeywords
    : [];

  const handleFileNameKeywordChange = (event, newValues) => {
    const normalizedKeywords = (newValues || [])
      .map((v) => (typeof v === "string" ? v.trim() : ""))
      .filter(Boolean);
    setFilterDownload({
      ...filterDownload,
      fileNameKeywords: normalizedKeywords,
    });
    setCurrentPageNumber(1);
  };

  return (
    <DashboardWrapper>
      <Grid container spacing={0} direction="row" justifyContent="center">
        <Grid item xs={12} lg={12}>
          <Grid
            container
            justifyContent={"center"}
            className={open ? classes.contentGridSlim : classes.contentGrid}
          >
            <Grid item xs={12} lg={10}>
              <Grid
                container
                direction="row"
                justifyContent={"space-between"}
                alignItems="flex-start"
                className={open ? classes.contentGridSlim : classes.contentGrid}
              >
                <Grid item>
                  <div className={classes.quickSearchWrap}>
                    <Autocomplete
                      multiple
                      freeSolo
                      id="download-filename-quick-search"
                      options={fileNameOptions}
                      open={false}
                      value={selectedFileNameKeywords}
                      onChange={handleFileNameKeywordChange}
                      filterSelectedOptions
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className={classes.quickSearchInput}
                          variant="outlined"
                          size="small"
                          label="ファイル名検索"
                        />
                      )}
                    />
                    <Typography className={classes.resultCount}>
                      件数: {filteredCount}件
                    </Typography>
                  </div>
                </Grid>
                <Grid item>
                  <DownloadCalendar companyName={companyName} />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} lg={10} className={classes.filtered}>
              <DownloadTable
                handleDrawerOpen={handleDrawerOpen}
                handleDrawerClose={handleDrawerClose}
                handleImageSelect={handleImageSelect}
                downloadImage={downloadImage}
                setDownloadImage={setDownloadImage}
                open={open}
                activeDownload={true}
                onFileNameOptionsChange={setFileNameOptions}
                onFilteredCountChange={setFilteredCount}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </DashboardWrapper>
  );
};

Download.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  filterDownload: state.download.filterDownload,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  setFilterDownload: (param) => dispatch(setFilterDownload(param)),
  setCurrentPageNumber: (param) => dispatch(setCurrentPageNumber(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Download);
